module.exports = __webpack_public_path__ + "public/img/tiku_cbg4select.fbaa4fc7.png";